// Servicio de routing para el portal de aplicaciones
export class RoutingService {
  private static instance: RoutingService;
  private currentApp: string | null = null;

  private constructor() {
    this.initializeRouting();
    this.setupPopstateListener();
  }

  public static getInstance(): RoutingService {
    if (!RoutingService.instance) {
      RoutingService.instance = new RoutingService();
    }
    return RoutingService.instance;
  }

  private initializeRouting(): void {
    // Detectar si estamos en una app específica o en el portal
    const path = window.location.pathname;
    const pathParts = path.split('/').filter(part => part !== '');
    
    if (pathParts.length > 0) {
      this.currentApp = pathParts[0];
    } else {
      this.currentApp = null;
    }
  }

  private setupPopstateListener(): void {
    // Escuchar cambios en la URL (botón atrás/adelante del navegador)
    window.addEventListener('popstate', () => {
      this.initializeRouting();
      // Disparar evento personalizado para notificar cambios
      window.dispatchEvent(new CustomEvent('routechange', { 
        detail: { currentApp: this.currentApp } 
      }));
    });
  }

  public getCurrentApp(): string | null {
    return this.currentApp;
  }

  public isInPortal(): boolean {
    return this.currentApp === null;
  }

  public isInApp(appId: string): boolean {
    return this.currentApp === appId;
  }

  public navigateToApp(appId: string): void {
    // Cambiar la URL sin recargar la página
    const newUrl = `/${appId}`;
    window.history.pushState({ appId }, '', newUrl);
    this.currentApp = appId;
    
    // Disparar evento personalizado
    window.dispatchEvent(new CustomEvent('routechange', { 
      detail: { currentApp: this.currentApp } 
    }));
  }

  public navigateToPortal(): void {
    // Cambiar la URL sin recargar la página
    window.history.pushState({}, '', '/');
    this.currentApp = null;
    
    // Disparar evento personalizado
    window.dispatchEvent(new CustomEvent('routechange', { 
      detail: { currentApp: this.currentApp } 
    }));
  }

  public getAppUrl(appId: string): string {
    return `/${appId}`;
  }

  public getPortalUrl(): string {
    return '/';
  }

  public getCurrentUrl(): string {
    return window.location.pathname;
  }
}

export const routingService = RoutingService.getInstance();
